import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'

export interface CoiRequestRow {
  id: string
  orgId: string
  orgName: string
  holderName: string
  email: string
  dateCreated: string
}

export function getCoiRequests(): Promise<CoiRequestRow[]> {
  return axios
    .get('/api/v1/insure/internal/coi-requests/')
    .then((r) => toCamelCase(r.data) as CoiRequestRow[])
}

export function useCoiRequests() {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [CacheKeys.COI_REQUESTS],
    queryFn: getCoiRequests,
  })
  return { rows: data ?? [], isLoading, refetch }
}
